import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AgentEmployeeService } from '../../services/agent-employee/agent-employee.service';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-agent-employee-delete-dialog',
  templateUrl: './agent-employee-delete-dialog.component.html',
  styleUrls: ['./agent-employee-delete-dialog.component.css']
})
export class AgentEmployeeDocsDeleteDialogComponent implements OnInit {
  logFormData: any;
  agentId: any;
  loginId: any;
  errMsg;
  errFlag: boolean = false;
  vendorName;
  firstName;
  lastName;
  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService, private agentEmployeeService: AgentEmployeeService,
    public dialogRef: MatDialogRef<AgentEmployeeDocsDeleteDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public agentData: any) { }

  ngOnInit() {
    this.agentId = localStorage.getItem("AgentId");
    this.loginId = localStorage.getItem('loginID');
    this.vendorName = localStorage.getItem('AgentName');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  deleteDocument(){
    this.logFormData = {
      "document_type": this.agentData.DocumentTypeName,
      "document_category": this.agentData.DocumentCategory,
      "transaction_type": "Delete",
      "vendor_id": this.agentId,
      "employee_name": localStorage.getItem('EmployeeName')
    }
    this.agentEmployeeService.deleteEmpDocuments(this.agentData).subscribe(res=>{
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Deleted a" + ' ' + this.agentData.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
      if(res.Status == 200){
        this.agentEmployeeService.load.next('success');
        this.logFormData.modified_by = this.loginId;
        this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{});
        this.onNoClick();
      }  
    }, err => {
      this.errMsg = err;
      this.errFlag = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/agent-employee-docs-delete-dialog/agent-employee-delete-dialog.component.ts